import { HeaderRightItemDesktop } from './HeaderRightItemDesktop';
import { HeaderRightItemMobile } from './HeaderRightItemMobile';

export const HeaderRightItemSlot = {
  desktop: HeaderRightItemDesktop,
  mobile: HeaderRightItemMobile,
};
